import { Alert, Button, Container, Loader, Stack, Text } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import type { EnabledModulesState } from "./useEnabledModules";

export interface ModulesPendingProps {
  readonly state: EnabledModulesState;
}

/**
 * Ожидание или ошибка загрузки состава модулей (ADR-0083, п. 4).
 * Показывается вместо раздела, пока состав неизвестен: «раздела нет»
 * говорит только ответ, в котором модуля нет.
 */
export function ModulesPending({ state }: ModulesPendingProps): ReactElement {
  const { t } = useTranslation();

  if (state.status === "error") {
    return (
      <Container py="xl">
        <Alert color="red" title={t("modules.errorHeading")}>
          <Stack gap="sm">
            <Text>{t("modules.loadError")}</Text>
            <Button variant="light" onClick={state.retry}>
              {t("modules.retry")}
            </Button>
          </Stack>
        </Alert>
      </Container>
    );
  }

  return (
    <Container py="xl">
      <Stack gap="md" align="center">
        <Loader />
        <Text>{t("modules.loading")}</Text>
      </Stack>
    </Container>
  );
}
